<template>
  <BaseAvatar
    :initials="initials"
    :size="size"
    :flat="flat"
    :ring-color="ringColor"
    :border-color="borderColor"
    hide-status
  />
</template>

<script>
import BaseAvatar from '@c/Avatar/BaseAvatar.vue'

/**
 * FM's UserAvatar look on Crema's users: initials only, Crema has neither
 * profile pictures nor online status. Takes the user object, or a name.
 */
export default {
  name: 'UserAvatar',
  components: { BaseAvatar },
  props: {
    user: { type: Object, default: null },
    name: { type: String, default: null },
    size: {
      type: String,
      default: 'medium',
      validator: (value) =>
        ['extra-small', 'small', 'medium', 'large', 'extra-large'].includes(
          value
        )
    },
    flat: { type: Boolean, default: false },
    ringColor: { type: String, default: null },
    borderColor: { type: String, default: null }
  },
  computed: {
    initials() {
      const { first_name, last_name, full_name } = this.user ?? {}
      if (first_name || last_name) {
        return `${first_name?.[0] ?? ''}${last_name?.[0] ?? ''}`.toUpperCase()
      }
      return (this.name ?? full_name ?? '')
        .split(/\s+/)
        .filter(Boolean)
        .slice(0, 2)
        .map((word) => word[0].toUpperCase())
        .join('')
    }
  }
}
</script>
